import React, {useEffect, useRef, useState} from "react";
import {useLoading} from "../components/loading/LoadingProvider";
import {
    Card,
    Col,
    Form,
    FormControl,
    FormGroup,
    FormLabel,
    FormSelect,
    Button,
    Row, FormCheck, Image, CardImg, CardBody, CardText
} from "react-bootstrap";
import * as domToImage from "dom-to-image";
import {useDevice} from "../components/device/DeviceProvider";
import {fetchPost, fetchUpload, post} from "../utils/FetchUtil";
import ErrorsAlert from "../components/alerts/ErrorsAlert";
import {img} from "../utils/ImageUtil";
import "../../style/template/wrapping_template_view.scss";
import {isEmpty, isNotEmpty} from "../utils/CommonUtil.ts";
import {popErrors} from "../utils/MessageUtil.ts";

interface WrappingTemplateViewProps{
    templateKbn?: string;
    orderNumber?: string;
    orderDetailNumber?: number;
    handleSaved: () => void;
    handleCanceled: () => void;
}

const WrappingTemplateView: React.FC<WrappingTemplateViewProps> = (
    {
        templateKbn = "00",
        orderNumber = "",
        orderDetailNumber = null,
        handleSaved = () => {},
        handleCanceled = () => {}
    }) => {
    const { isMobile } = useDevice();
    const { showLoading, hideLoading } = useLoading();
    const noshiPreviewRef = useRef<HTMLDivElement | undefined>(undefined);
    const [errorList, setErrorList] = useState([]);
    const [validated, setValidated] = useState(false);
    //包装紙の選択
    const [paperUseOptionId, setPaperUseOptionId] = useState(-1);
    const [paperUseOptions, setPaperUseOptions] = useState([]);
    const [selectedPaperUse, setSelectedPaperUse] = useState(1);
    const [paperOptionId, setPaperOptionId] = useState(-1);
    const [paperChoiceList, setPaperChoiceList] = useState([]);
    const [selectedPaper, setSelectedPaper] = useState(-1);
    //のしの選択
    const [noshiUseOptionId, setNoshiUseOptionId] = useState(-1);
    const [noshiUseOptions, setNoshiUseOptions] = useState([]);
    const [selectedNoshiUse, setSelectedNoshiUse] = useState(-1);
    const [noshiPaperOptionId, setNoshiPaperOptionId] = useState(-1);
    const [noshiChoiceList, setNoshiChoiceList] = useState([]);
    const [selectedNoshiPaperId, setSelectedNoshiPaperId] = useState(-1);

    //のし入力
    const [sendMethodSamples, setSendMethodSamples] = useState([]);
    const [returnMethodSamples, setReturnMethodSamples] = useState([]);
    const [noshiTopOptionId, setNoshiTopOptionId] = useState(100);
    const [noshiBottomOptionId, setNoshiBottomOptionId] = useState(170);
    const [bottomNameOptionId, setBottomNameOptionId] = useState(225);
    const [bottomLeftOptionId, setBottomLeftOptionId] = useState(102);
    const [bottomRightOptionId, setBottomRightOptionId] = useState(103);
    const [bottomCompanyOptionId, setBottomCompanyOptionId] = useState(223);
    const [bottomDepartmentOptionId, setBottomDepartmentOptionId] = useState(224);

    const [selectedNoshiTop, setSelectedNoshiTop] = useState(0);
    const [selectedNoshiBottom, setSelectedNoshiBottom] = useState(0);

    //のしプレビュー用
    const [noshiSizeClass, setNoshiSizeClass] = useState("mame");
    const [noshiWidth, setNoshiWidth] = useState(643);
    const [noshiHeight, setNoshiHeight] = useState(283);
    const [selectedNoshiPaper, setSelectedNoshiPaper] = useState("");
    const [selectedNoshiName, setSelectedNoshiName] = useState("");
    const [noshiImagePath, setNoshiImagePath] = useState("");
    //のし上
    const [noshiTop, setNoshiTop] = useState("");
    const [noshiTopClass, setNoshiTopClass] = useState("noshi-top-val");
    const [noshiKindClass, setNoshiKindClass] = useState("");
    //のし下
    const [noshiNameLeft, setNoshiNameLeft] = useState("");
    const [noshiNameRight, setNoshiNameRight] = useState("");
    const [noshiNameClass, setNoshiNameClass] = useState("");
    const [noshiCompany, setNoshiCompany] = useState("");
    const [noshiDepartment, setNoshiDepartment] = useState("");

    const [isNoshiBottomEmpty, setIsNoshiBottomEmpty] = useState(false);

    useEffect(() => {
        setNoshiImagePath("");
    }, [noshiTop, noshiNameLeft, noshiNameRight, noshiCompany, noshiDepartment]);

    useEffect(() => {
        if(isNotEmpty(noshiImagePath)){
            createNoshiImage();
        }
    }, [selectedNoshiPaperId, isNoshiBottomEmpty]);

    useEffect(() => {
        const initPage = async () =>{
            showLoading();
            try{
                const data = await fetchPost({
                    action: "/api/template/input/wrapping",
                    data: {template_kbn: templateKbn},
                });
                viewWrappingInput(data);
            }catch (e) {
                setErrorList([e.message]);
            }
        }
        initPage().finally(()=>{hideLoading()});
    }, []);
    useEffect( () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [errorList]);
    const viewWrappingInput = (data) => {
        //包装紙の選択
        setPaperUseOptionId(data["paper_use_option_id"]);
        setPaperUseOptions(data["paper_use_choice_list"]);
        setSelectedPaperUse(1);
        setPaperOptionId(data["paper_option_id"])
        setPaperChoiceList(data["paper_choice_list"]);

        //のしの選択
        setNoshiUseOptionId(data["noshi_use_option_id"]);
        setNoshiUseOptions(data["noshi_use_choice_list"]);
        //setSelectedNoshiUse(1);
        setNoshiPaperOptionId(data["noshi_option_id"]);
        setNoshiChoiceList(data["noshi_choice_list"]);

        //のしの入力
        setNoshiSizeClass(data["noshi_size_class"]);
        setNoshiTopOptionId(data["noshi_top_option_id"]);
        setNoshiBottomOptionId(data["noshi_bottom_option_id"]);
        setBottomNameOptionId(data["bottom_name_option_id"]);
        setBottomLeftOptionId(data["bottom_left_option_id"]);
        setBottomRightOptionId(data["bottom_right_option_id"]);
        setBottomCompanyOptionId(data["bottom_commpany_option_id"]);
        setBottomDepartmentOptionId(data["bottom_department_option_id"]);
        setSendMethodSamples(data["send_type_samples"]);
        setReturnMethodSamples(data["return_type_samples"]);
        setSelectedNoshiTop(0);
        setSelectedNoshiBottom(0);

    }
    const handlePaperUseChange = ( evt ) => {
        setSelectedPaperUse(parseInt(evt.target.value));
        if(parseInt(evt.target.value) === 0){
            setSelectedPaper(-1);
        }
    }
    const handlePaperChange = ( evt ) => {
        setSelectedPaper(parseInt(evt.target.value));
    }
    const handleNoshiUseChange = ( evt ) => {
        setSelectedNoshiUse(parseInt(evt.target.value));
        if(parseInt(evt.target.value) === 0){
            clearNoshiInput();
        }
    }
    const clearNoshiInput = () => {
        setSelectedNoshiPaperId(-1);
        setSelectedNoshiPaper("");
        setNoshiImagePath("");
        setNoshiTop("");
        setNoshiNameLeft("");
        setNoshiNameRight("");
        setNoshiCompany("");
        setNoshiDepartment("");
        setNoshiImagePath("");
    }
    const handleNoshiPaperChange = ( noshiDto ) => {
        setSelectedNoshiPaperId(parseInt(noshiDto["option_detail_id"]));
        setSelectedNoshiPaper(noshiDto["option_image_path"]);
        setSelectedNoshiName(noshiDto["option_detail_name"]);
        // setNoshiKindClass(noshiDto["noshi_kind_class"]);
        // setNoshiWidth(noshiDto["noshi_width"]);
        // setNoshiHeight(noshiDto["noshi_height"]);
    }
    const handleNoshiTopChange = ( evt ) => {
        setSelectedNoshiTop(parseInt(evt.target.value));
        resetNoshiTopInput();
    }

    const resetNoshiTopInput = () => {
        const cmbSendMethod = document.getElementById("cmbSendMethodSamples");
        const cmbReturnMethod = document.getElementById("cmbReturnMethodSamples");
        const txtOther = document.getElementById("txtOtherInput");
        if(txtOther){
            txtOther.value = "";
        }
        if(cmbSendMethod){
            cmbSendMethod.value = "";
        }
        if(cmbReturnMethod){
            cmbReturnMethod.value = "";
        }
        setNoshiTop("");
        setNoshiImagePath("");
    }
    const handleNoshiTopInputChange = ( evt ) => {
        const inputVal = evt.target.value;
        setNoshiTop(inputVal);
        //setNoshiTopClass(`noshi-top-val word-${inputVal.length}`);
    }
    //のし下入力の切り替える
    const handleNoshiBottomChange = ( evt ) => {
        setSelectedNoshiBottom(parseInt(evt.target.value));
        resetPreviewNoshiButton();
    }
    const resetPreviewNoshiButton = () => {
        setNoshiNameLeft("");
        setNoshiNameRight("");
        setNoshiCompany("");
        setNoshiDepartment("");
        setNoshiImagePath("");
    }
    const onChangedNoshiNameLeft = ( evt ) => {
        const inputVal = evt.target.value;
        setNoshiNameLeft(inputVal);
        // if(inputVal.length > noshiNameRight.length){
        //     setNoshiNameClass(`noshi-bottom-val word-${inputVal.length}`);
        // }else{
        //     setNoshiNameClass(`noshi-bottom-val word-${noshiNameRight.length}`);
        // }
    }
    const onChangedNoshiNameRight = ( evt ) => {
        const inputVal = evt.target.value;
        setNoshiNameRight(inputVal);
        // if(inputVal.length > noshiNameLeft.length){
        //     setNoshiNameClass(`noshi-bottom-val word-${inputVal.length}`);
        // }else {
        //     setNoshiNameClass(`noshi-bottom-val word-${noshiNameLeft.length}`);
        // }
    }
    const onChangedNoshiCompany = ( evt ) => {
        const inputVal = evt.target.value;
        setNoshiCompany(inputVal);
    }
    const onChangedNoshiDepartment = ( evt ) => {
        const inputVal = evt.target.value;
        setNoshiDepartment(inputVal);
    }

    const onClickSave = ( evt ) =>{
        let frmWrap = document.getElementById("wrapInputForm");
        if(frmWrap.checkValidity() === false){
            evt.preventDefault();
            evt.stopPropagation();
        }
        setValidated(true);
        if(selectedPaperUse !== 0 && selectedPaper === -1){
            popErrors("包装紙を選択してください。");
        }else{
            if(frmWrap.checkValidity()){
                setValidated(false);
                entryTemplate();
            }else{
                popErrors("のし情報をご確認ください。");
            }
        }
    }

    const createNoshiImage = () => {
        let frmWrap = document.getElementById("wrapInputForm");
        setValidated(true);
        if(frmWrap.checkValidity()){
            showLoading();
            setValidated(false);
            post<any>({
                action: "/api/template/wrapping/noshi/preview",
                data: {detail_list: buildNoshiDetails()}
            })
                .then((data) => {
                    if(data && isNotEmpty(data["template_image_path"])) {
                        setNoshiImagePath(data["template_image_path"]);
                    }else {
                        setNoshiImagePath("");
                    }
                })
                .catch((reason) => {
                    console.log(reason);
                })
                .finally(() => {
                    hideLoading();
                });
        }else{
            popErrors("のし情報をご確認ください。");
            setNoshiImagePath("");
        }
    };

    const entryTemplate = async (template_image_path = null) =>{
        showLoading();
        try{
            const data = await fetchPost({
                action: "/api/template/wrapping/entry",
                data: createEntryData(template_image_path),
            });
            if(data !== null){
                handleSaved();
            }
        }catch (e) {
            setErrorList([e.message]);
        }finally {
            hideLoading();
        }
    }
    const createEntryData = (template_image_path) => {
      let templateDto = {};
      templateDto["template_kbn"] = templateKbn;
      templateDto["order_number"] = orderNumber;
      templateDto["order_detail_number"] = orderDetailNumber;
      let templateName = "";
      if(selectedNoshiUse !== 0){
          templateDto["image_path"] = template_image_path;
          if(selectedNoshiUse === 1){
              templateName = "内のし/" + noshiTop;
          }else{
              templateName = "外のし/" + noshiTop;
          }
      }else{
          templateName = "のし無し";
      }
      templateDto["template_name"] = templateName;
      return {template: templateDto, detail_list: buildNoshiDetails()};
    }
    const buildNoshiDetails = (): any => {
        let templateDetails = [];
        if(selectedPaperUse !== 0){
            templateDetails.push({option_id: paperOptionId, option_detail_id: selectedPaper});
        }
        if(selectedNoshiUse !== 0){
            templateDetails.push({option_id: noshiUseOptionId, option_detail_id: selectedNoshiUse});
            templateDetails.push({option_id: noshiPaperOptionId, option_detail_id: selectedNoshiPaperId});
            templateDetails.push({option_id: noshiTopOptionId, option_detail_id: -1, input_text: noshiTop});
            templateDetails.push({option_id: noshiBottomOptionId, option_detail_id: selectedNoshiBottom});
            if(selectedNoshiBottom === 0){
                templateDetails.push({option_id: bottomNameOptionId, option_detail_id: -1, input_text: noshiNameLeft});
            }else if(selectedNoshiBottom === 1){
                templateDetails.push({option_id: bottomLeftOptionId, option_detail_id: -1, input_text: noshiNameLeft});
                templateDetails.push({option_id: bottomRightOptionId, option_detail_id: -1, input_text: noshiNameRight});
            }else if(selectedNoshiBottom === 2){
                templateDetails.push({option_id: bottomCompanyOptionId, option_detail_id: -1, input_text: noshiCompany});
                templateDetails.push({option_id: bottomDepartmentOptionId, option_detail_id: -1, input_text: noshiDepartment});
                templateDetails.push({option_id: bottomNameOptionId, option_detail_id: -1, input_text: noshiNameLeft});
            }else if(selectedNoshiBottom === 3){
                templateDetails.push({option_id: bottomCompanyOptionId, option_detail_id: -1, input_text: noshiCompany});
                templateDetails.push({option_id: bottomNameOptionId, option_detail_id: -1, input_text: noshiNameLeft});
            }
        }
        return templateDetails
    }
    const onClickCancel = ( evt ) => {
        handleCanceled();
    };
    const onChangeNoshiBottomEmpty = (event) => {
        setIsNoshiBottomEmpty(event.target.checked);
        if(event.target.checked){
            resetPreviewNoshiButton();
        }
    };
  return (
      <section className="mb-5">
          <h2 className="template-title">包装・のしの選択</h2>
          <ErrorsAlert error_list={errorList}></ErrorsAlert>
          <Form className="container-fluid wrap-input-view" id="wrapInputForm" noValidate validated={validated}>
              <Row className="mt-5">
                  <Col xs={12}>
                      <dl className="use-option">
                          <dt>包装</dt>
                          {paperUseOptions && paperUseOptions.length != 0 && paperUseOptions.map(opt =>
                              <dd key={`dd_wrap_use_${opt["option_detail_id"]}`}>
                                  <Form.Check
                                      inline
                                      type="radio"
                                      name="wrap-use-option"
                                      id={`rdo_wrap_use_${opt["option_detail_id"]}`}
                                      label={opt["option_detail_name"]}
                                      value={opt["option_detail_id"]}
                                      checked={selectedPaperUse === opt["option_detail_id"]}
                                      onChange={handlePaperUseChange}
                                  />
                              </dd>)}
                      </dl>
                  </Col>
              </Row>
              {selectedPaperUse > 0 && <Row className="mt-3">
                  <Col xs={12}>
                      <div className="wrap-paper-list">
                          {paperChoiceList && paperChoiceList.length != 0 && paperChoiceList.map((paper) => <div key={`paper_choice_item_${paper["option_detail_id"]}`} className={`wrap-paper-item ${selectedPaper === paper["option_detail_id"] ? 'selected-card' : ''}`}>
                              <Card>
                                  <Card.Img variant="top" src={img(paper["option_image_path"])} onClick={() => {setSelectedPaper(paper["option_detail_id"])}} />
                              </Card>
                              <FormGroup>
                                  <Form.Check
                                      inline
                                      type="radio"
                                      name="paper-choice-option"
                                      id={`radio_paper_choice_${paper["option_detail_id"]}`}
                                      label={paper["option_detail_name"]}
                                      value={paper["option_detail_id"]}
                                      onChange={handlePaperChange}
                                      checked={selectedPaper === paper["option_detail_id"]}
                                  />
                              </FormGroup>
                          </div>)}
                      </div>
                  </Col>
              </Row>}
              <Row className="mt-5">
                  <Col xs={12}>
                      <dl className="use-option">
                          <dt>のし</dt>
                          {noshiUseOptions && noshiUseOptions.length != 0 && noshiUseOptions.map(opt =>
                              <dd key={`dd_noshi_use_${opt["option_detail_id"]}`}>
                                  <Form.Check
                                      inline
                                      key={`rdo_noshi_use_${opt["option_detail_id"]}`}
                                      id={`rdo_noshi_use_${opt["option_detail_id"]}`}
                                      type="radio"
                                      label={opt["option_detail_name"]}
                                      name="noshi-use-option"
                                      value={opt["option_detail_id"]}
                                      checked={selectedNoshiUse === opt["option_detail_id"]}
                                      onChange={handleNoshiUseChange}
                                  />
                              </dd>)}
                      </dl>
                      <p className="use-noshi-detail">
                          ※一般的に、結婚式当日にゲスト様へ直接お渡しする場合は「外のし」、ゲスト様へ宅配でお届けする場合は、熨斗の破れ防止のため「内のし」がおすすめです。
                      </p>
                  </Col>
              </Row>
              {selectedNoshiUse > 0 && <Row className="mt-3">
                  <Col xs={12}>
                      <div className="noshi-paper-list">
                          <Row>
                              <Col xs={12}>
                                  <h3>1. のし種類をお選びください</h3>
                              </Col>
                          </Row>
                          <Row>
                              {noshiChoiceList && noshiChoiceList.length != 0 && noshiChoiceList.map((noshi) => <Col xs={6} md={3} key={`noshi_choice_${noshi["option_detail_id"]}`} className={`noshi-paper-item ${selectedNoshiPaperId === noshi["option_detail_id"] ? 'selected-card' : ''}`}>
                                  <Card className="noshi-paper-card">
                                      <Card.Img variant="top" src={img(noshi["option_image_path"])} onClick={ () => {handleNoshiPaperChange(noshi)}} />
                                  </Card>
                                  <FormGroup>
                                      <Form.Check
                                          inline
                                          required
                                          type="radio"
                                          name="noshi-choice-option"
                                          id={`radio_noshi_choice_${noshi["option_detail_id"]}`}
                                          label={noshi["option_detail_name"]}
                                          value={noshi["option_detail_id"]}
                                          onChange={()=>{handleNoshiPaperChange(noshi)}}
                                          checked={selectedNoshiPaperId === noshi["option_detail_id"]}
                                      />
                                      <p className="noshi-detail">
                                          {noshi["goods_detail"]}
                                      </p>
                                  </FormGroup>
                              </Col>)}
                          </Row>
                      </div>
                      <div className="noshi-input-area">
                          <div className="noshi-input-left">
                              <Image src={img(`${isNotEmpty(noshiImagePath)? noshiImagePath : selectedNoshiPaper}`)} fluid={true}/>
                              <p className="noshi-name">{selectedNoshiName}</p>
                          </div>
                          <div className="noshi-input-right flex-fill">
                              <h3>2. のし上をお選びください</h3>
                              <p className="noshi-bottom-notes"><span className="text-danger">※不要の場合はその他を選択し、スペースをご入力ください。</span></p>
                              <dl>
                                  <dt>
                                      <Form.Check
                                          inline
                                          type="radio"
                                          id="noshi-top-send"
                                          label="ギフトを贈る方"
                                          name="noshi-top-option"
                                          value={0}
                                          checked={selectedNoshiTop === 0}
                                          onChange={handleNoshiTopChange}
                                      />
                                  </dt>
                                  <dd>
                                      <FormSelect id="cmbSendMethodSamples" disabled={selectedNoshiTop !== 0} onChange={handleNoshiTopInputChange} required>
                                          <option value="">選択してください</option>
                                          {sendMethodSamples && sendMethodSamples.length != 0 && sendMethodSamples.map((sample, idx) => <option key={`cmb_send_sample_${idx}`} value={sample}>{sample}</option>)}
                                      </FormSelect>
                                      <Form.Control.Feedback type="invalid">
                                          のしの上を選択してください。
                                      </Form.Control.Feedback>
                                  </dd>
                              </dl>
                              <dl>
                                  <dt>
                                      <Form.Check
                                          inline
                                          type="radio"
                                          id="noshi-top-return"
                                          label="お返しをする方"
                                          name="noshi-top-option"
                                          value={1}
                                          checked={selectedNoshiTop === 1}
                                          onChange={handleNoshiTopChange}
                                      />
                                  </dt>
                                  <dd>
                                      <FormSelect id="cmbReturnMethodSamples" disabled={selectedNoshiTop !== 1} onChange={handleNoshiTopInputChange} required>
                                          <option value="">選択してください</option>
                                          {returnMethodSamples && returnMethodSamples.length != 0 && returnMethodSamples.map((sample, idx) => <option key={`cmb_return_sample_${idx}`} value={sample}>{sample}</option>)}
                                      </FormSelect>
                                      <Form.Control.Feedback type="invalid">
                                          のしの上を選択してください。
                                      </Form.Control.Feedback>
                                  </dd>
                              </dl>
                              <dl>
                                  <dt>
                                      <Form.Check
                                          inline
                                          type="radio"
                                          id="noshi-top-other"
                                          label="その他"
                                          name="noshi-top-option"
                                          value={9}
                                          checked={selectedNoshiTop === 9}
                                          onChange={handleNoshiTopChange}
                                      />
                                  </dt>
                                  <dd>
                                      <FormControl id="txtOtherInput" type="text" disabled={selectedNoshiTop !== 9} onChange={handleNoshiTopInputChange} maxLength="5" required></FormControl>
                                      <Form.Control.Feedback type="invalid">
                                          のしの上を入力してください。
                                      </Form.Control.Feedback>
                                  </dd>
                              </dl>
                              <h3 className="mt-5">
                                  3. のし下の記載方法を入力ください
                              </h3>
                              <FormGroup>
                                  <FormCheck
                                      type="switch"
                                      label="記名なし"
                                      checked={isNoshiBottomEmpty}
                                      onChange={onChangeNoshiBottomEmpty}
                                      className={`noshi-bottom-empty-switch`}
                                  />
                              </FormGroup>
                              {!isNoshiBottomEmpty && <>
                                  <FormGroup>
                                      <Form.Check
                                          inline
                                          type="radio"
                                          id="noshi-bottom-row"
                                          name="noshi-bottom-option"
                                          label="１列"
                                          value={0}
                                          checked={selectedNoshiBottom === 0}
                                          onChange={handleNoshiBottomChange}
                                      />
                                      <Form.Check
                                          inline
                                          type="radio"
                                          id="noshi-bottom-2rows"
                                          name="noshi-bottom-option"
                                          label="２列"
                                          value={1}
                                          checked={selectedNoshiBottom === 1}
                                          onChange={handleNoshiBottomChange}
                                      />
                                      <Form.Check
                                          inline
                                          type="radio"
                                          id="noshi-bottom-company"
                                          name="noshi-bottom-option"
                                          label="会社用"
                                          value={2}
                                          checked={selectedNoshiBottom === 2}
                                          onChange={handleNoshiBottomChange}
                                      />
                                      <Form.Check
                                          inline
                                          type="radio"
                                          id="noshi-bottom-company-2rows"
                                          name="noshi-bottom-option"
                                          label="会社用(２列)"
                                          value={3}
                                          checked={selectedNoshiBottom === 3}
                                          onChange={handleNoshiBottomChange}
                                      />
                                  </FormGroup>
                                  <p className="noshi-bottom-notes mt-3 text-danger">
                                      ※前後に全角スペースを入れることで位置等の調整が可能。
                                      {selectedNoshiBottom === 0 &&
                                          <>
                                              <br/>
                                              ※出産内祝の場合は苗字のみか、お子様のお名前のみを記入するのが一般的です。
                                          </>
                                      }
                                      {selectedNoshiBottom === 1 &&
                                          <>
                                              <br/>
                                              ※出産内祝の場合は苗字のみか、お子様のお名前のみを記入するのが一般的です。
                                              <br/>
                                              ※婚礼の場合、右側に新郎様、左側に新婦様のお名前を記載するのが一般的です。
                                          </>
                                      }
                                  </p>
                                  {selectedNoshiBottom === 0 && <div>
                                      <FormGroup className="mt-3">
                                          <FormLabel style={{width: '100%'}}>お名前<span className="float-end">{noshiNameLeft.length}/10</span></FormLabel>
                                          <FormControl type="text" placeholder="例）山田義彦" maxLength={10} onChange={onChangedNoshiNameLeft} required></FormControl>
                                          <Form.Control.Feedback type="invalid">
                                              お名前を入力してください。
                                          </Form.Control.Feedback>
                                      </FormGroup>
                                  </div>}
                                  {selectedNoshiBottom === 1 && <div>
                                      <FormGroup className="mt-3">
                                          <FormLabel style={{width: '100%'}}>お名前（左側）<span className="float-end">{noshiNameLeft.length}/10</span></FormLabel>
                                          <FormControl type="text" maxLength={10} onChange={onChangedNoshiNameLeft} required placeholder={"婚礼の場合、新婦様"}></FormControl>
                                          <Form.Control.Feedback type="invalid">
                                              お名前（左側）を入力してください。
                                          </Form.Control.Feedback>
                                      </FormGroup>
                                      <FormGroup className="mt-3">
                                          <FormLabel style={{width: '100%'}}>お名前（右側）<span className="float-end">{noshiNameRight.length}/10</span></FormLabel>
                                          <FormControl type="text" maxLength={10} onChange={onChangedNoshiNameRight} required placeholder={"婚礼の場合、新郎様"}></FormControl>
                                          <Form.Control.Feedback type="invalid">
                                              お名前（右側）を入力してください。
                                          </Form.Control.Feedback>
                                      </FormGroup>
                                  </div>}
                                  {selectedNoshiBottom === 2 && <div>
                                      <FormGroup className="mt-3">
                                          <FormLabel style={{width: '100%'}}>会社名<span className="float-end">{noshiCompany.length}/12</span></FormLabel>
                                          <FormControl type="text" maxLength={12} placeholder="例）株式会社OOO" onChange={onChangedNoshiCompany} required></FormControl>
                                          <Form.Control.Feedback type="invalid">
                                              会社名を入力してください。
                                          </Form.Control.Feedback>
                                      </FormGroup>
                                      <FormGroup className="mt-3">
                                          <FormLabel style={{width: '100%'}}>役職名<span className="float-end">{noshiDepartment.length}/12</span></FormLabel>
                                          <FormControl type="text" maxLength={12} placeholder="例）代表取締役" onChange={onChangedNoshiDepartment} required></FormControl>
                                          <Form.Control.Feedback type="invalid">
                                              役職名を入力してください。
                                          </Form.Control.Feedback>
                                      </FormGroup>
                                      <FormGroup className="mt-3">
                                          <FormLabel style={{width: '100%'}}>お名前<span className="float-end">{noshiNameLeft.length}/10</span></FormLabel>
                                          <FormControl type="text" maxLength={10} placeholder="例）山田　太郎" onChange={onChangedNoshiNameLeft} required></FormControl>
                                          <Form.Control.Feedback type="invalid">
                                              お名前を入力してください。
                                          </Form.Control.Feedback>
                                      </FormGroup>
                                  </div>}
                                  {selectedNoshiBottom === 3 && <div>
                                      <FormGroup className="mt-3">
                                          <FormLabel style={{width: '100%'}}>会社名<span className="float-end">{noshiCompany.length}/12</span></FormLabel>
                                          <FormControl type="text" maxLength={12} placeholder="例）株式会社OOO" onChange={onChangedNoshiCompany} required></FormControl>
                                          <Form.Control.Feedback type="invalid">
                                              会社名を入力してください。
                                          </Form.Control.Feedback>
                                      </FormGroup>
                                      <FormGroup className="mt-3">
                                          <FormLabel style={{width: '100%'}}>お名前<span className="float-end">{noshiNameLeft.length}/10</span></FormLabel>
                                          <FormControl type="text" maxLength={10} placeholder="例）山田　太郎" onChange={onChangedNoshiNameLeft} required></FormControl>
                                          <Form.Control.Feedback type="invalid">
                                              お名前を入力してください。
                                          </Form.Control.Feedback>
                                      </FormGroup>
                                  </div>}
                              </>}
                              <div className="preview-button-notes">
                                  <Button className="btn-noshi-preview" variant="success" onClick={createNoshiImage}>　上記の入力でプレビュー　</Button>
                                  <p className="preview-note text-danger">プレビューしてから保存してください</p>
                              </div>
                          </div>
                      </div>
                  </Col>
              </Row>}
          </Form>
          <div className="buttons-area">
              <Button variant="light" onClick={onClickCancel}>戻る</Button>
              {selectedPaperUse === 1 && selectedNoshiUse === 0 && <Button variant="secondary" onClick={onClickSave} disabled={selectedPaper === -1}>保　存</Button>}
              {selectedNoshiUse !== 0 && <Button variant="secondary" onClick={onClickSave} disabled={isEmpty(noshiImagePath)}>保　存</Button>}
          </div>
      </section>
  );
};
export default WrappingTemplateView;